import { render, staticRenderFns } from "./RfxManageTeam.vue?vue&type=template&id=83601c0a"
import script from "./RfxManageTeam.vue?vue&type=script&lang=js"
export * from "./RfxManageTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports